// @ts-nocheck
import { checkboxSizes } from "@insite/mobius/Checkbox";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { formFieldLabelStyles } from "@store/Themes/common/mixins/formField";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const checkboxDescriptionSpacingStyles = () => {
    return css<{ _sizeVariant: keyof typeof checkboxSizes }>`
        ${({ _sizeVariant = "default" }) => {
            const { descriptionSpacing } = checkboxSizes[_sizeVariant] as any;

            return css`
                > ${TypographyStyle} {
                    &:first-child {
                        ${formFieldLabelStyles()}
                        margin-bottom: ${pxToRem(descriptionSpacing)};
                    }

                    &:last-child {
                        margin-top: ${pxToRem(descriptionSpacing)};
                    }
                }
            `;
        }}
    `;
};
